import { render, staticRenderFns } from "./TeachResSeriesList.vue?vue&type=template&id=531361f7&"
import script from "./TeachResSeriesList.vue?vue&type=script&lang=js&"
export * from "./TeachResSeriesList.vue?vue&type=script&lang=js&"
import style0 from "./TeachResSeriesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports